/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Button } from '@material-ui/core/'
import BanModal from '../BanModal'
import apiAdmin from '../../../../../../../api/admin'
import avatarIcon from '../../../../../../../assetss/img/avatarIcon.svg'
import './index.scss'

const Banned = () => {
  const { user } = useSelector(({ session }) => session)
  const [usersBaned, setUsersBaned] = useState([])
  const [open, setOpen] = useState(false)
  const [unBlockUser, setUnBlockUser] = useState({
    name: '',
    email: '',
  })

  const getUserBlocked = () => {
    apiAdmin?.userBlocked(user?.accessKey)
      .then(({ data }) => {
        if (data?.users?.length) {
          setUsersBaned(data?.users)
        } else {
          setUsersBaned([])
        }
      })
  }

  const unBlockUserHandler = () => {
    apiAdmin?.unBlockUser(user?.accessKey, unBlockUser?.email)
      .then(({ data }) => {
        setUnBlockUser({})
        setOpen(false)
        getUserBlocked()
      })
  }

  useEffect(() => {
    getUserBlocked()
  }, [])

  return (
    <Grid className='reportStory'>
      <BanModal open={open} setOpen={setOpen} unBlockUserHandler={unBlockUserHandler} setUnBlockUser={setUnBlockUser} name={unBlockUser?.email} />
      <Grid className='tableHeader'>
        <Grid className='headerName'>
          Name
        </Grid>
        <Grid className='headerMeetings'>
          Email
        </Grid>
        <Grid className='headerStories'>
          City
        </Grid>
        <Grid className='headerCity'>
          Action
        </Grid>
      </Grid>
      {usersBaned?.map(({ name, email, town }) => (
        <Grid className='tableBody' key={email}>
          <Grid className='bodyName'>
            <span><img src={avatarIcon} className='iconAvatar' /> {name}</span>
          </Grid>
          <Grid className='bodyEmail'>
            <span>
              {email}
            </span>
          </Grid>
          <Grid className='bodyCity'>
            <span>
              {town ? user?.town : '-'}
            </span>
          </Grid>
          <Grid className='bodyAction'>
            <Button
              onClick={() => {
                setOpen(true)
                setUnBlockUser({
                  name,
                  email,
                })
              }}
              className='btnDelete'
              variant='contained'
            >
              UNBLOCK
            </Button>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export default Banned
